import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "37",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      "fill-rule": "evenodd",
      d: "M13.8.9a2.2 2.2 0 0 0-1.968 1.216L10.24 5.3H2.8a2.2 2.2 0 0 0 0 4.4v22a4.4 4.4 0 0 0 4.4 4.4h17.6a4.4 4.4 0 0 0 4.4-4.4v-22a2.2 2.2 0 0 0 0-4.4h-7.44l-1.592-3.184A2.2 2.2 0 0 0 18.2.9zM9.4 14.1a2.2 2.2 0 0 1 4.4 0v13.2a2.2 2.2 0 0 1-4.4 0zm11-2.2a2.2 2.2 0 0 0-2.2 2.2v13.2a2.2 2.2 0 0 0 4.4 0V14.1a2.2 2.2 0 0 0-2.2-2.2",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }